import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, Sizes } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';

export interface ITextWithCopyStyles {
  root?: IStyle;
  header?: IStyle;
  body?: IStyle;
  contents?: IStyle;
}

export const textWithCopyStylesDefault: Partial<ITextWithCopyStyles> = {
  root: { display: 'inline-flex', lineHeight: 25, maxWidth: '100%', fontSize: FontSizes.textPrimary },
  header: {
    paddingRight: '0.5rem',
  },
  body: {
    ...CommonStyles.code,
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    paddingTop: 0,
    paddingBottom: 0,
  },
  contents: {
    flex: 1,
    ...CommonStyles.truncateString,
  },
};

export const textWithCopyStylesPlain: Partial<ITextWithCopyStyles> = {
  header: {
    paddingRight: 4,
  },
  body: {
    backgroundColor: 'transparent',
    color: 'inherit',
    borderRadius: 'none',
    padding: 0,
    button: {
      left: 0,
      color: 'inherit',
      i: {
        color: 'inherit',
      },
    },
  },
};

export const textWithCopyStylesBorder = (theme: IH2OTheme): Partial<ITextWithCopyStyles> => ({
  root: {
    display: 'inline-flex',
    maxWidth: '100%',
    lineHeight: Sizes.height - 2,
    '&.has-header': {
      '.h2o-TextWithCopy-contents': {
        borderLeft: 0,
        borderRadius: 0,
      },
    },
  },
  header: {
    border: `1px solid ${theme.palette?.gray300}`,
    borderRadius: `${Sizes.borderRadius}px 0 0 ${Sizes.borderRadius}px`,
    paddingLeft: Sizes.padding,
    paddingRight: Sizes.padding,
    backgroundColor: theme.palette?.white,
  },
  body: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: theme.palette?.white,
    borderRadius: 0,
    padding: 0,
  },
  contents: {
    border: `1px solid ${theme.palette?.gray300}`,
    borderRight: 0,
    borderRadius: `${Sizes.borderRadius}px 0 0 ${Sizes.borderRadius}px`,
    paddingLeft: Sizes.padding,
    paddingRight: Sizes.padding,
    ...CommonStyles.truncateString,
    flex: 1,
  },
});

export const textWithCopyStylesNoHeaderStyle: Partial<ITextWithCopyStyles> = {
  header: {
    border: 0,
    padding: 0,
    borderRadius: 'none',
  },
};

export const textWithCopyStylesFill: Partial<ITextWithCopyStyles> = {
  root: {
    width: '100%',
  },
};
